import React from 'react';
import { useParams, Link } from 'react-router-dom';
import Notenrechner from '../components/Notenrechner';
import PdfDownloads from '../components/PdfDownloads';
import QuestionComments from '../components/QuestionComments';

export default function BerufIndexTemplate() {
  const { slug } = useParams();

  const formattedName = slug
    ? slug.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')
    : 'Elektroinstallateur/in EFZ';

  return (
    <div className="min-h-screen bg-[#0b1329] text-white p-4 sm:p-8 max-w-4xl mx-auto font-sans pb-24">
      <div className="mb-6">
        <Link to="/" className="inline-block bg-[#141c2e] border border-slate-700 text-[#22c55e] font-bold text-sm px-4 py-2 rounded-lg">
          ← Zurück zur Startseite
        </Link>
      </div>

      <div className="bg-[#141c2e] border border-slate-800 rounded-2xl p-5 sm:p-8 shadow-2xl mb-8">
        <div className="flex items-start sm:items-center gap-3 sm:gap-4 mb-4">
          <div className="w-12 h-12 sm:w-14 sm:h-14 bg-[#0b1329] border border-slate-700 rounded-xl flex items-center justify-center text-2xl sm:text-3xl shrink-0">
            ⚡
          </div>
          <h1 className="text-lg sm:text-3xl font-extrabold text-white leading-tight break-words max-w-full">
            LAP Vorbereitung: {formattedName}
          </h1>
        </div>

        <p className="text-slate-300 text-xs sm:text-base leading-relaxed mt-2">
          Die Schweizer Lernplattform für deine Lehrabschlussprüfung (LAP). Starte jetzt mit zielgerichteten Prüfungsfragen und lerne optimal.
        </p>
      </div>

      <Notenrechner />
      <PdfDownloads />
      <QuestionComments questionId={slug || 'all-questions'} />
    </div>
  );
}
